import { render, staticRenderFns } from "./base-add-button.vue?vue&type=template&id=713e4a7a&scoped=true&"
import script from "./base-add-button.vue?vue&type=script&lang=js&"
export * from "./base-add-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713e4a7a",
  null
  
)

export default component.exports